import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { assertDefinedAndNotNull } from '@orus.eu/error'

import { useTRPC } from '../../../../../../../client.ts'
import { ContractAddPaymentMethodPage } from '../../../../../../../components/pages/contract/contract-add-payment-method-page.tsx'
import { PermissionChecker } from '../../../../../../../components/templates/permission-checker.tsx'

function ContractAddPaymentMethodRoute(): React.JSX.Element {
  const { subscriptionId } = Route.useParams()
  const trpc = useTRPC()
  const { data: contracts } = useSuspenseQuery(
    trpc.contracts.getMyContract.queryOptions({ subscriptionId, includeTerminatedBeforeOneMonth: true }),
  )
  const contract = assertDefinedAndNotNull(contracts[0], 'Contract not found', { subscriptionId })
  return (
    <PermissionChecker requiredPermissions={['paymentAccount.update']}>
      <ContractAddPaymentMethodPage
        subscriptionId={subscriptionId}
        operatingZone={contract.operatingZone}
        contractNumber={contract.contractNumber}
        companyName={contract.companyName}
      />
    </PermissionChecker>
  )
}

export const Route = createFileRoute('/(customer)/_portal/contracts/$subscriptionId/payment-methods/new')({
  component: ContractAddPaymentMethodRoute,
})
